import './Settings.css';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSetRecoilState, useRecoilValue } from 'recoil';
import { navigationBarState } from '../../states/NavigationBar';
import { LoggedInState } from '../../states/LoggedIn';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

function Settings() {
    const navigate = useNavigate();
    const setNavigationBarState = useSetRecoilState(navigationBarState);
    const loggedIn = useRecoilValue(LoggedInState);

    useEffect(() => {
        window.scrollTo(0, 0);
        setNavigationBarState({
            title: '설정',
            'left-item': { type: 'back' },
        });
    }, [setNavigationBarState]);

    return (
        <div className="settings-page">
            <div className="settings-container">
                {/* Account Info */}
                <div className="settings-section">
                    <div className="settings-section-label">계정 정보</div>
                    <div className="settings-info-card">
                        <div className="settings-info-row">
                            <span className="settings-info-label">아이디</span>
                            <span className="settings-info-value">{loggedIn?.user?.username}</span>
                        </div>
                        <div className="settings-info-row">
                            <span className="settings-info-label">이름</span>
                            <span className="settings-info-value">{loggedIn?.user?.nickname}</span>
                        </div>
                    </div>
                </div>

                {/* Information */}
                <div className="settings-section">
                    <div className="settings-section-label">정보</div>
                    <div
                        className="settings-menu-item"
                        onClick={() => navigate('/terms-of-service')}
                    >
                        <span className="settings-menu-text">서비스이용약관</span>
                        <span className="settings-menu-arrow">
                            <ChevronRightIcon />
                        </span>
                    </div>
                    <div
                        className="settings-menu-item"
                        onClick={() => navigate('/privacy-policy')}
                    >
                        <span className="settings-menu-text">개인정보처리방침</span>
                        <span className="settings-menu-arrow">
                            <ChevronRightIcon />
                        </span>
                    </div>
                </div>

                {/* Account Management - 회원탈퇴 임시 숨김
                <div className="settings-section">
                    <div className="settings-section-label">계정 관리</div>
                    <div
                        className="settings-menu-item danger"
                        onClick={() => navigate('/settings/delete-account')}
                    >
                        <span className="settings-menu-text">회원탈퇴</span>
                        <span className="settings-menu-arrow">
                            <ChevronRightIcon />
                        </span>
                    </div>
                </div>
                */}

                {/* Footer */}
                <div className="settings-footer">
                    <div className="settings-footer-text">통번역자격시험</div>
                </div>
            </div>
        </div>
    );
}

export default Settings;
